<template>
    <v-main class="primary">
        <transition name="fade" mode="out-in">
            <loader-component v-if="loading"></loader-component>
            <router-view v-else></router-view>
        </transition>
    </v-main>
</template>
<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
</style>
<script>
    import { mapActions, mapMutations, mapGetters } from 'vuex'
    import LoaderComponent from '../../components/LoaderComponent.vue'

    export default {
        components: {
            LoaderComponent,
        },

        async created() {
            this.ENABLE_LOADER()
            this.$vuetify.theme.themes.light.primary = '#fffbf2'
            this.$vuetify.theme.themes.light.secondary = '#F5B940'
            this.$vuetify.theme.themes.light.accent = '#F58634'
            this.$vuetify.theme.themes.light.anchor = '#F5B940'

            await this.fetchPrincipios()
            await this.fetchReactivos()
            await this.fetchFrecuenciaRespetoPrincipio()
            await this.fetchPeriodicidad()
            await this.fetchResultados()
            await this.fetchFunciones()
            await this.fetchIndicadores()
            await this.fetchFrecuenciaProductividad()
            await this.fetchActosRelevantes()
            await this.fetchProcedimiento()

            await this.fetchConvocatoria(1)
            await this.fetchPromociones()
            await this.fetchTipoConvocatoria()
            await this.fetchCondecoraciones()
            await this.fetchMunicipios()
            await this.fetchEstados()
            await this.fetchEstadoCivil()
            await this.fetchTipoNacionalidad()
            await this.fetchSexo()
            await this.fetchGrupoSanguineo()

            this.DISABLE_LOADER()
        },

        computed: {
            ...mapGetters({
                loading: 'getLoader',
            }),
        },

        methods: {
            ...mapActions('personal', ['fetchPersonal']),

            ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
            ...mapActions('principio', ['fetchPrincipios']),
            ...mapActions('reactivo', ['fetchReactivos']),
            ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
            ...mapActions('periodicidad', ['fetchPeriodicidad']),
            ...mapActions('resultado', ['fetchResultados']),
            ...mapActions('productividad', ['fetchProductividad']),
            ...mapActions('funcion', ['fetchFunciones']),
            ...mapActions('indicador', ['fetchIndicadores']),
            ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
            ...mapActions('actoRelevante', ['fetchActosRelevantes']),
            ...mapActions('municipio', ['fetchMunicipios']),
            ...mapActions('convocatoria', ['fetchConvocatoria']),
            ...mapActions('tipoConvocatoria', ['fetchTipoConvocatoria']),
            ...mapActions('promociones', ['fetchPromociones']),
            ...mapActions('condecoraciones', ['fetchCondecoraciones']),
            ...mapActions('procedimiento', ['fetchProcedimiento']),
            ...mapActions('estadoCivil', ['fetchEstadoCivil']),
            ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
            ...mapActions('sexo', ['fetchSexo']),
            ...mapActions('grupoSanguineo', ['fetchGrupoSanguineo']),
            ...mapActions('estado', ['fetchEstados']),

            ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),
        },
    }
</script>
